import { createSlice } from "@reduxjs/toolkit";

import {
  requestSignUpStatus,
  requestSignInStatus,
  requestSignOutStatus,
  requestSocialAuthStatus,
  requestGithubLinkStatus,
  requestUserInfoStatus,
  requestActivateAccountStatus,
  requestResendActivationStatus,
  requestRecoverPasswordStatus,
  validateInvitationStatus,
} from "../effects/auth-effects";
import { slices } from "../../constants/sliceNames";

const initialState = {
  userToken: null,
  userName: "",
  errorMsg: null,
  remember: false,
  isGithub: false,
  recoverStatus: false,
  resendActivationStatus: false,
  userRole: [],
  fetchDone: false,
  userInfo: {},
  userID: "",
  organizations: [],
  loading: false,
  validating: false,
  invitationValid: undefined,
};

const authSlice = createSlice({
  name: slices.auth,
  initialState,
  reducers: {},
  extraReducers: {
    ...requestSignUpStatus,
    ...requestSignInStatus,
    ...requestSignOutStatus,
    ...requestSocialAuthStatus,
    ...requestGithubLinkStatus,
    ...requestUserInfoStatus,
    ...requestActivateAccountStatus,
    ...requestResendActivationStatus,
    ...requestRecoverPasswordStatus,
    ...validateInvitationStatus,
  },
});

const { actions, reducer } = authSlice;

export { actions, initialState };

export default reducer;
